export default "__VITE_ASSET__DeODPhiT__"